/** InsCoder WANG.J 2026-08-15 B + Product page 50/50 popup behavior **/
(() => {
  const popup = document.getElementById('product-ab-popup');

  if (!popup) {
    return;
  }

  const storageKey = 'theme:popup-appeared';
  const showOnce = popup.dataset.showOnce === 'true';
  const image = popup.querySelector('[data-product-ab-image]');
  const coupon = popup.querySelector('[data-product-ab-coupon]');
  const couponCode = popup.querySelector('[data-product-ab-code]');
  const copyButton = popup.querySelector('[data-product-ab-copy]');
  const copyStatus = popup.querySelector('[data-product-ab-copy-status]');
  let hasTriggered = false;
  let timerId = null;
  let scrollHandler = null;
  let resizeHandler = null;
  let imageLoadHandler = null;
  let imageErrorHandler = null;

  const hasAppeared = () => {
    if (!showOnce) {
      return false;
    }

    try {
      return window.localStorage.getItem(storageKey) !== null;
    } catch (error) {
      return false;
    }
  };

  const markAppeared = () => {
    if (!showOnce) {
      return;
    }

    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Storage is unavailable. Continue without persistence.
    }
  };

  const cleanupImageListeners = () => {
    if (imageLoadHandler) {
      image.removeEventListener('load', imageLoadHandler);
      imageLoadHandler = null;
    }

    if (imageErrorHandler) {
      image.removeEventListener('error', imageErrorHandler);
      imageErrorHandler = null;
    }
  };

  const cleanupTriggerListeners = () => {
    if (timerId !== null) {
      window.clearTimeout(timerId);
      timerId = null;
    }

    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }

    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
      resizeHandler = null;
    }
  };

  const cleanupListeners = () => {
    cleanupTriggerListeners();
    cleanupImageListeners();
  };

  const triggerPopup = (group) => {
    if (hasTriggered || hasAppeared() || !image) {
      return;
    }

    hasTriggered = true;

    const imageSource = group === 'a' ? popup.dataset.imageA : popup.dataset.imageB;
    const imageSrcset = group === 'a' ? popup.dataset.imageASrcset : popup.dataset.imageBSrcset;
    const imageWidth = Number(group === 'a' ? popup.dataset.imageAWidth : popup.dataset.imageBWidth);
    const imageHeight = Number(group === 'a' ? popup.dataset.imageAHeight : popup.dataset.imageBHeight);
    const discountCode = group === 'a' ? popup.dataset.discountCodeA : popup.dataset.discountCodeB;

    if (!imageSource) {
      cleanupListeners();
      return;
    }

    const normalizedDiscountCode = (discountCode || '').trim();

    if (coupon) {
      coupon.hidden = !normalizedDiscountCode;
    }

    if (couponCode) {
      couponCode.textContent = normalizedDiscountCode;
    }

    if (copyButton) {
      copyButton.dataset.copyValue = normalizedDiscountCode;
    }

    if (copyStatus) {
      copyStatus.textContent = '';
    }

    const clearImageSource = () => {
      image.hidden = true;
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
    };

    const handleImageError = () => {
      cleanupListeners();
      clearImageSource();
      popup.open = false;
    };

    const handleImageLoad = () => {
      if (!image.naturalWidth) {
        handleImageError();
        return;
      }

      cleanupImageListeners();
      image.hidden = false;
      popup.open = true;
      markAppeared();
    };

    clearImageSource();
    imageLoadHandler = handleImageLoad;
    imageErrorHandler = handleImageError;
    image.addEventListener('load', imageLoadHandler, { once: true });
    image.addEventListener('error', imageErrorHandler, { once: true });
    image.srcset = imageSrcset || '';
    image.sizes = '(max-width: 740px) calc(100vw - 40px), min(calc(100vw - 160px), 528px)';

    if (Number.isFinite(imageWidth) && imageWidth > 0) {
      image.width = imageWidth;
    }

    if (Number.isFinite(imageHeight) && imageHeight > 0) {
      image.height = imageHeight;
    }

    image.alt = popup.dataset.imageAlt || '';
    cleanupTriggerListeners();
    image.src = imageSource;

    if (image.complete) {
      if (image.naturalWidth) {
        handleImageLoad();
      } else {
        handleImageError();
      }
    }
  };

  const delaySeconds = Number(popup.dataset.aDelay);
  const scrollThreshold = Number(popup.dataset.bThreshold);
  const group = Math.random() < 0.5 ? 'a' : 'b';

  if (hasAppeared()) {
    return;
  }

  if (group === 'a') {
    if (Number.isFinite(delaySeconds) && delaySeconds >= 0) {
      timerId = window.setTimeout(() => triggerPopup('a'), delaySeconds * 1000);
    }
  } else if (Number.isFinite(scrollThreshold) && scrollThreshold >= 0 && scrollThreshold <= 100) {
    const checkScrollThreshold = () => {
      const documentHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
      const scrollableHeight = Math.max(documentHeight - window.innerHeight, 0);
      const scrollProgress = scrollableHeight === 0 ? 100 : ((window.scrollY / scrollableHeight) * 100);

      if (scrollProgress >= scrollThreshold) {
        triggerPopup('b');
      }
    };

    scrollHandler = checkScrollThreshold;
    resizeHandler = checkScrollThreshold;
    window.addEventListener('scroll', scrollHandler, { passive: true });
    window.addEventListener('resize', resizeHandler, { passive: true });
    checkScrollThreshold();
  }

  const fallbackCopy = (value) => {
    const helper = document.createElement('textarea');
    helper.className = 'product-ab-popup__copy-helper';
    helper.value = value;
    helper.setAttribute('readonly', '');
    helper.setAttribute('aria-hidden', 'true');
    document.body.appendChild(helper);
    helper.select();

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    helper.remove();
    return copied;
  };

  if (copyButton) {
    copyButton.addEventListener('click', async () => {
      const value = copyButton.dataset.copyValue || '';
      let copied = false;

      if (!value.trim()) {
        return;
      }

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(value);
          copied = true;
        } catch (error) {
          copied = false;
        }
      }

      if (!copied) {
        copied = fallbackCopy(value);
      }

      if (copyStatus) {
        copyStatus.textContent = copied
          ? (copyButton.dataset.copySuccessLabel || '')
          : (copyButton.dataset.copyFailureLabel || '');
      }
    });
  }

  window.addEventListener('pagehide', cleanupListeners, { once: true });
})();
/** InsCoder WANG.J 2026-08-15 E + Product page 50/50 popup behavior **/
